module.exports = __webpack_public_path__ + "static/media/google-play-word-best-innovative-game@2x.b864590b.png";